module.exports = __webpack_public_path__ + "assets/img/box7_img1.e497e80b.png";